import { Card, Tag, Rate, Flex } from "antd";
import React from "react";

export default function TourCard({ tour, onClick  }) {
  if (!tour) return null; // Safety check

  const {
    title = "Untitled Tour",
    type = "Standard",
    imageUrl = "https://via.placeholder.com/400x250?text=No+Image",
    final_price = 0,
    old_price = 0,
    save_price = 0,
    duration = "N/A",
    rating = 4.9,
    reviewCount = 0,
  } = tour;

  return (
    <Card
      onClick={onClick }
      hoverable
      className="rounded-2xl shadow-md overflow-hidden [&_.ant-card-body]:p-3"
    >
      <Flex  className="flex-col md:flex-row" gap={20}>
        <img
          alt={title}
          src={imageUrl}
          className="w-full md:w-56 h-36 object-cover rounded-xl"
        />

        <Flex justify="space-between" vertical>
          {/* Tour Type */}
          <div className="text-xs font-medium">
            Tour Type
            <Tag className="bg-blue-100 text-black font-semibold rounded border-0 text-xs ml-2 py-1">
              {type}
            </Tag>
          </div>

          {/* Title */}
          <h4 className="font-medium text-base leading-snug">{title}</h4>

          {/* Price */}
          <div className="flex flex-col">
            <span className="font-bold text-lg text-black">
              AED {final_price.toLocaleString()}
            </span>
            
          </div>

          {/* Bottom row */}
          <Flex gap={10} align="center" className="text-sm mt-2">
            <div className="text-primary font-medium">{duration}</div>
            <Flex align="center" className="text-danger font-medium">
              <div className="text-xl">★</div>
              <div className="text-xs ml-1">
                {rating} ({reviewCount})
              </div>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
